import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertService, MenuService, MaterialesTipoService, UsuariosService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-materialestipo',
  templateUrl: './materialestipo.component.html'
})
export class MaterialesTipoComponent implements OnInit {

  form: FormGroup;
  dataMaterialesTipo: any;
  mySelection: number[] = [];
  navigationSubscription;
  isDeleting = false;

  modalReference: NgbModalRef;
  user = this.userService.userValue;

  constructor(private materialesTipoService: MaterialesTipoService,
    private alertService: AlertService,
    private menuService: MenuService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private userService: UsuariosService,
    private modalService: NgbModal) {

    this.menuService.titulo = this.translateService.instant('materialestipo').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/materialestipo') {
          this.cargarDatos();
        }
      }
    });

  }

  cargarDatos() {
    this.materialesTipoService.getAll().pipe(first()).subscribe((result) => {
      this.dataMaterialesTipo = result;
    });
  }

  ngOnInit(): void {

  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['materialestipo/editar/', this.mySelection[0]]);
    }
  }

  onClickEditar() {
    if (this.mySelection[0] > 0) {
      this.router.navigate(['materialestipo/editar/', this.mySelection[0]]);
    }
  }

  onClickNuevo() {
    this.router.navigate(['materialestipo/crear']);
  }

  onClickEliminar(content) {
    if (this.mySelection[0] > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  eliminarRegistro() {

    this.mySelection.forEach(element => {
      if (element > 0) {
        this.isDeleting = true;
        this.form = this.formBuilder.group({
          id: element
        });
        this.materialesTipoService.delete(this.form.value.id).pipe(first()).subscribe({
          next: () => {
            this.dataMaterialesTipo = this.dataMaterialesTipo.filter(x => x.id !== element);
            this.isDeleting = false;
            this.alertService.success(this.translateService.instant('eliminadocorrectamente'), { keepAfterRouteChange: true });
            this.router.navigate(['../materialestipo'], { relativeTo: this.route });
          },
          error: error => {
            this.isDeleting = false;
            this.alertService.error(error);
          }
        });
      }
    });

    this.modalReference.close();
    this.mySelection = [];

  }

}
